import { Injectable } from '@angular/core';
import { NgxIndexedDB } from 'ngx-indexed-db';
import {
  HttpClient
} from "@angular/common/http";
import { map } from 'rxjs/operators';
import { MainService, IResponse } from './main.service';
// import { openDB, deleteDB, wrap, unwrap } from 'https://unpkg.com/idb?module';
// import idb from 'idb';
// import { openDB } from 'idb';
@Injectable({
  providedIn: 'root'
})
export class DbContextService {
  dbName = 'ipos';
  dbTableName = 'Items';
  dbVersion = 1;
  db: any;
  itemCount: number = 0;
  constructor(private http: HttpClient, private ms: MainService) {
    if (!('indexedDB' in window)) {
      throw new Error('This browser doesn\'t support IndexedDB');
    }
    this.onLoad();
  }
  CreateTable(keyPath: string, TableName = this.dbTableName, Version = this.dbVersion) {
    let db = new NgxIndexedDB(this.dbName, Version);
    // db.openDatabase()
    db.openDatabase(Version, evt => {
      let objectStore = evt.currentTarget.result.createObjectStore(TableName, { keyPath: keyPath });

    })
  }
  onLoad() {
    this.db = new NgxIndexedDB(this.dbName, this.dbVersion);
    this.db.openDatabase(this.dbVersion, evt => {
      let objectStore = evt.currentTarget.result.createObjectStore(this.dbTableName, { keyPath: "Barcode", autoIncrement: false });
      let setting = evt.currentTarget.result.createObjectStore("Settings", { keyPath: "CounterOpenId", autoIncrement: false });
      // objectStore.createIndex("Barcode", "Barcode", { unique: true });
    }).then(res => {
    }).catch(res => {
    }).finally(() => {
      // this.loadItems();
    });;
    // this.db.openDatabase(this.dbVersion, evt => {
    //   let objectStore = evt.currentTarget.result.createObjectStore(this.dbTableName, { keyPath: "Barcode", autoIncrement: false });
    //   // objectStore.createIndex("Barcode", "Barcode", { unique: true });
    // });
    // this.db.
  }
  Add(body) {
    return this.getItem(body.Barcode).then(e => {
      if (e) {
        return this.db.update(this.dbTableName, body)
      } else {
        return this.db.add(this.dbTableName, body)
      }
    })
  }
  Update(body) {
    return this.db.update(this.dbTableName, body)
  }
  getItem(id) {
    return this.db.getByKey(this.dbTableName, id)
  }
  getAll() {
    return this.db.getAll(this.dbTableName)
  }
  AddBulk(body, TableName = this.dbTableName, Version = this.dbVersion) {
    let db = new NgxIndexedDB(this.dbName, Version);
    return db.add(TableName, body)
  }





  Get_ItemSearch(body) {
    return this.http
      .post(this.ms.baseUrl + "/services/api/v1/Get_ProductSearch", body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }

  loadItems(start = 0) {
    var data = {
      SellingPricelevel: 1,
      Branch: 1,
      Location: 1,
      RequestedList: {
        Start: start,
        FiterText: "",
        Limit: 100,
        ItemTypeId: 1,
        CAType: 1
      },
      FilterData: {
        Name: "",
        Barcode: "",
        RefNo: "",
        CostPrice: 0,
        SellingPrice: 0,
        SupplierName: "",
        Dept: "",
        Cat: "",
        SubCat: "",
        Unit: ""
      }
    }
    this.Get_ItemSearch(data).subscribe(res => {
      if (res.Success) {
        if (start == 0) {
          this.itemCount = res.total;
        }
        start += 100;
        if (start < this.itemCount) {
          // this.loadItems(start);
        }
        for (let i of res.data) {

          // this.Add(i)
        }
      }
    })
  }

  
  Get_SerialItemSearch(body) {
    return this.http
      .post(this.ms.baseUrl + "/services/api/v1/pos/Get_SerialItemSearch", body, {
        headers: this.ms.getHeader()
      })
      .pipe(map((response: IResponse) => {
        return response;
      }));
  }
}
